import React from "react";
import ReactApexChart from "react-apexcharts";

class DefaultLineChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: [],
      chartOptions: null,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      chartData: nextProps.chartData,
      chartOptions: {
      ...this.state.chartOptions,
        xaxis: {
        ...this.state.chartOptions.xaxis,
          categories: nextProps.categories
      }
    }
    });
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData,
      chartOptions: {
        ...this.props.chartOptions,
        xaxis: {
          ...this.props.chartOptions.xaxis,
          categories: this.props.categories
        }
      }
    });
  }

  render() {
    if (this.state.chartOptions) {
      return (
        <ReactApexChart options={this.state.chartOptions} series={this.state.chartData} type="area" width="100%" height="100%"/>
      )
    } else {
      return (
        <></>
      );
    }
  }
}

export default DefaultLineChart;
